import React, { Component } from "react"
import constants from "../constants"
import { Application, Container, filters, Sprite } from 'pixi.js'
import { gsap } from 'gsap'
import Breakpoints from "./breakpoints"

class ExploreSection extends Component {
  constructor(props) {
    super(props)
    this.parentEl = React.createRef()
    this.wrapperEl = React.createRef()
    this.canvasEl = React.createRef()
    this.captionEl = React.createRef()
    this.captionTextEl = React.createRef()
    this.imageHolderEl = React.createRef()
    this.wrapper = undefined
    this.img = undefined
    this.depthMap = undefined
    this.displacementFilter = undefined
    this.imagesLoaded = false
    this.mousePosition = { x: 0, y: 0, nX: 0, nY: 0 }
    this.size = { w: 0, h: 0 }
  }
  componentDidMount() {
    this.tl = gsap.timeline()
    this.tl.from(this.parentEl.current, {duration: 0.6, autoAlpha: 0, ease: `expo.out`}, 0.2)
    this.tl.from(this.captionEl.current, {duration: 0.8, y: 20, scaleY: 0.8, autoAlpha: 0, ease: `expo.out`}, 0.6)
    // this.tl.from(this.captionTextEl.current, {duration: 0.8, y: 10, autoAlpha: 0, ease: `expo.out`}, 0.8)
    this.tl.pause(0)
    this.mainImage = this.parentEl.current.getElementsByClassName(`picture-position`)[0]
    if (this.mainImage) this.parentEl.current.className = this.mainImage.className
    // this.wrapperEl.current.classList.add(`overflow-hidden`)
    this.app = new Application({
      view: this.canvasEl.current,
      backgroundAlpha: 0,
      autoDensity: true,
      resolution: window.devicePixelRatio || 1,
      width: this.parentEl.current.clientWidth,
      height: this.parentEl.current.clientHeight
    })
    this.wrapper = new Container()
    this.app.stage.addChild(this.wrapper)
    this.app.stop()
    this.observer = new IntersectionObserver(this.onIntersect, {
      rootMargin: `150px 0px 150px 0px`,
      threshold: 0
    })
    gsap.set(this.imageHolderEl.current, { transformPerspective: 200 })
    gsap.set(this.captionTextEl.current, { transformPerspective: 250 })
    this.observer.observe(this.parentEl.current)
    window.addEventListener('mousemove', this.onMouseMove)
    window.addEventListener('resize', this.onResize)
    this.onResize()
  }
  onMouseMove = (e) => {
    this.mousePosition.x = e.clientX
    this.mousePosition.y = e.clientY
    this.mousePosition.nX = (this.mousePosition.x / window.innerWidth) * 2 - 1
    this.mousePosition.nY = (this.mousePosition.y / window.innerHeight) * 2 - 1
  }
  loadScene = () => {
    if (this.imagesLoaded) return
    const mq = Breakpoints(window.innerWidth)
    const imgSrc = `${constants.IMG_PATH}images/${this.props.anchorName}_explore/${this.props.anchorName}_explore,w_${mq.id}.jpg`
    if (window.isMobile) {
      const img = this.wrapperEl.current.firstChild
      const newImg = new Image
      newImg.onload = () => {
        img.src = newImg.src
        img.classList.remove(`tw-opacity-0`)
      }
      newImg.src = imgSrc
    } else {
      this.img = new Sprite.from(imgSrc)
      this.depthMap = new Sprite.from(`${constants.IMG_PATH}images/${this.props.anchorName}_map/${this.props.anchorName}_map,w_${mq.id}.jpg`)
      this.displacementFilter = new filters.DisplacementFilter(this.depthMap)
      this.wrapper.addChild(this.depthMap)
      this.wrapper.addChild(this.img)
      this.wrapper.filters = [this.displacementFilter]
      this.wrapper.width = this.img.width = this.depthMap.width = this.size.w
      this.wrapper.height = this.img.height = this.depthMap.height = this.size.h
    }
    this.imagesLoaded = true
  }
  onUpdate = () => {
    const rX = -this.mousePosition.nX * 0.4
    const rY = this.mousePosition.nY * 0.4
    gsap.to(this.imageHolderEl.current, {
      rotateX: `${rY}deg`,
      rotateY: `${rX}deg`,
      ease: "expo",
      duration: 0.8,
      overwrite: true
    })
    gsap.to(this.captionTextEl.current, {
      rotateX: `${rY*10}deg`,
      rotateY: `${rX*6}deg`,
      ease: "expo",
      duration: 1,
      overwrite: true
    })
    if (this.displacementFilter) {
      // const newX = (this.size.w / 2 - this.mousePosition.x) / this.props.scaleX
      // const newY = (this.size.h / 2 - this.mousePosition.y) / this.props.scaleY
      const newX = -this.mousePosition.nX * this.props.scaleX * 2
      const newY = -this.mousePosition.nY * this.props.scaleY * 2
      this.displacementFilter.scale.x += (newX - this.displacementFilter.scale.x) * 0.2
      this.displacementFilter.scale.y += (newY - this.displacementFilter.scale.y) * 0.2
    }
  }
  onIntersect = (entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        this.loadScene()
        this.app.start()
        this.app.ticker.add(this.onUpdate)
        this.tl.timeScale(1).play(0)
        if (this.exploreTl) this.exploreTl.play()
      } else {
        this.app.ticker.remove(this.onUpdate)
        this.tl.pause(0)
        this.app.stop()
        if (this.exploreTl) this.exploreTl.pause()
      }
    })
  }
  componentWillUnmount() {
    if (this.observer) this.observer.disconnect()
    window.removeEventListener('mousemove', this.onMouseMove)
    window.removeEventListener('resize', this.onResize)
  }
  onResize = () => {
    const w = this.parentEl.current.clientWidth
    const h = this.parentEl.current.clientHeight
    this.size.w = w
    this.size.h = h
    if (this.wrapperEl.current) {
      this.wrapperEl.current.style.width = `${w}px`
      this.wrapperEl.current.style.height = `${h}px`
    }
    if (this.img && this.depthMap && this.wrapper) {
      this.wrapper.width = this.img.width = this.depthMap.width = w
      this.wrapper.height = this.img.height = this.depthMap.height = h
    }
    this.app.resize(w, h)
  }
  render() {
    return (
      <div ref={this.parentEl} data-anchor={this.props.anchorName} className={`${this.props.className} explore-section`}>
        <div ref={this.captionEl} className={`${constants.caption} tw-absolute tw-bottom-0 tw-left-1/2 tw-transform tw--translate-x-1/2 tw-translate-t-1/2 tw-z-20`}>
          <div ref={this.captionTextEl} style={{ transform: `translateZ(30px)` }} className={`force-font-family !tw-leading-none !tw-font-sans !tw-text-xs tw-uppercase tw-bg-brown tw-text-white tw-text-center tw-py-3 tw-px-4 ${window.isMobile ? `tw-opacity-0` : `tw-opacity-100`}`}>{constants.UI.rollover}</div>
        </div>
        { !window.isMobile &&
          <div ref={this.imageHolderEl} style={{ transform: `translateZ(-4px)` }} className={`tw-relative tw-z-10`}>
            <div className={`tw-relative tw-z-0 ${window.webglAvailable ? `tw-opacity-0` : `tw-opacity-100`}`}>
              {this.props.children}
            </div>
            { window.webglAvailable &&
              <div className={`tw-absolute tw-z-10 tw-w-full tw-h-full tw-top-0 tw-left-0`}>
                <div ref={this.wrapperEl}>
                  <canvas className={`tw-shadow-2xl`} ref={this.canvasEl}></canvas>
                </div>
              </div>
            }
          </div>
        }
        { window.isMobile &&
        <>
          <div ref={this.imageHolderEl} style={{ transform: `translateZ(-4px)` }} className={`tw-relative tw-z-10`}>
            <div className={`tw-relative tw-z-0 tw-opacity-100`}>
              {this.props.children}
            </div>
          </div>
          <div className={`tw-absolute tw-z-10 tw-w-full tw-h-full tw-top-0 tw-left-0`}>
            <div ref={this.wrapperEl}><img className={`tw-transition-opacity tw-duration-500 tw-ease-in-out tw-opacity-0`}/></div>
          </div>
        </>
        }
      </div>
    )
  }
}

ExploreSection.defaultProps = {
  scaleX: 22,
  scaleY: 14
}

export default ExploreSection